module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-05.5df92883.png";